export default "__VITE_ASSET__CAmWoHlv__ 640w, __VITE_ASSET__yI6aN8pl__ 1024w, __VITE_ASSET__DVRwp27t__ 1920w";